import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/modules/auth'

const dataState = new createPersistedState({
    //Persistimos únicamente las variables que necesitamos
    reducer: (state) => ({
        auth: {
            token: state.auth.token,
            refreshToken: state.auth.refreshToken
        }
    })
})

export default createStore({
    plugins: [dataState],
    state: {
        isLoading: false
    },
    mutations: {
        setLoading(state, bool) {
            state.isLoading = bool
        }
    },
    actions: {
        setLoading({ commit }, isLoading) {
            commit('setLoading', isLoading, { root: true })
        }
    },
    modules: {
        auth
    }
})
